import React from "react";
import { Link } from "react-router-dom";

const WHATSAPP = "919873385555";

const plans = [
  {
    name: "GPU Starter",
    badge: null,
    gpu: "1× NVIDIA RTX 4070",
    vram: "12 GB GDDR6X",
    cpu: "16 vCPU AMD EPYC",
    ram: "64 GB DDR5",
    storage: "1 TB NVMe SSD",
    bandwidth: "1 Gbps Unmetered",
    price: "₹18,000",
    yearly: "₹1,98,000/yr",
    tags: ["AI Inference", "ML Training", "Rendering"],
    color: "#6366f1",
  },
  {
    name: "GPU Pro",
    badge: "Most Popular",
    gpu: "2× NVIDIA RTX 4090",
    vram: "48 GB GDDR6X",
    cpu: "32 vCPU AMD EPYC",
    ram: "128 GB DDR5",
    storage: "2 TB NVMe SSD",
    bandwidth: "10 Gbps Unmetered",
    price: "₹45,000",
    yearly: "₹4,95,000/yr",
    tags: ["Deep Learning", "LLM Fine-tuning", "Video AI"],
    color: "#BC13FE",
  },
  {
    name: "GPU Enterprise",
    badge: "High Performance",
    gpu: "4× NVIDIA A100 80G",
    vram: "320 GB HBM2e",
    cpu: "64 vCPU AMD EPYC",
    ram: "512 GB DDR5",
    storage: "8 TB NVMe RAID",
    bandwidth: "25 Gbps Unmetered",
    price: "₹1,20,000",
    yearly: "₹12,00,000/yr",
    tags: ["Foundation Models", "HPC", "Enterprise AI"],
    color: "#00F3FF",
  },
];

const wa = (plan) => {
  const msg = encodeURIComponent(`Hello! I am interested in the *${plan}* GPU Server plan from IndiaCloud.ai. Please share availability and onboarding details. Thank you!`);
  window.open(`https://wa.me/${WHATSAPP}?text=${msg}`, "_blank");
};

export default function GpuServers() {
  return (
    <div style={{ background: "#030305", minHeight: "100vh", paddingTop: 100, paddingBottom: 80, fontFamily: "inherit" }}>
      {/* Hero */}
      <div style={{ textAlign: "center", marginBottom: 60, padding: "0 20px" }}>
        <div style={{ display: "inline-block", padding: "4px 16px", borderRadius: 999, background: "rgba(188,19,254,0.12)", border: "1px solid rgba(188,19,254,0.35)", color: "#BC13FE", fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", marginBottom: 16 }}>
          ⚡ GPU-ACCELERATED CLOUD
        </div>
        <h1 style={{ fontSize: "clamp(2rem,5vw,3.5rem)", fontWeight: 800, margin: "0 0 16px", background: "linear-gradient(135deg, #00F3FF, #BC13FE)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
          GPU Server Plans
        </h1>
        <p style={{ color: "#9ca3af", fontSize: 18, maxWidth: 540, margin: "0 auto 32px" }}>
          Enterprise-grade GPU infrastructure for AI, ML, rendering and HPC — hosted in India.
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: 12, flexWrap: "wrap" }}>
          {["No Shared Resources", "NVLink Support", "India Datacenter", "24/7 NOC"].map(f => (
            <span key={f} style={{ padding: "6px 14px", borderRadius: 999, background: "rgba(0,243,255,0.07)", border: "1px solid rgba(0,243,255,0.2)", color: "#00F3FF", fontSize: 13 }}>✓ {f}</span>
          ))}
        </div>
      </div>

      {/* Cards */}
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 20px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 24 }}>
        {plans.map(plan => (
          <div key={plan.name} style={{ borderRadius: 20, border: `1px solid ${plan.color}40`, background: `linear-gradient(135deg, ${plan.color}12 0%, rgba(3,3,5,0.98) 60%)`, padding: 28, display: "flex", flexDirection: "column", boxShadow: `0 0 40px ${plan.color}18`, transition: "transform 0.2s, box-shadow 0.2s", position: "relative" }}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = `0 20px 60px ${plan.color}30`; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = `0 0 40px ${plan.color}18`; }}
          >
            {plan.badge && (
              <span style={{ position: "absolute", top: 20, right: 20, background: `${plan.color}22`, border: `1px solid ${plan.color}44`, color: plan.color, fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 999 }}>{plan.badge}</span>
            )}
            <div style={{ fontSize: 12, color: plan.color, fontWeight: 700, letterSpacing: "0.08em", marginBottom: 6, textTransform: "uppercase" }}>⚡ {plan.gpu}</div>
            <h2 style={{ margin: "0 0 4px", fontSize: 22, fontWeight: 800, color: "#fff" }}>{plan.name}</h2>
            <div style={{ color: plan.color, fontSize: 13, marginBottom: 20, opacity: 0.8 }}>{plan.vram} VRAM</div>

            <div style={{ background: "rgba(255,255,255,0.04)", borderRadius: 12, padding: "12px 16px", marginBottom: 20, display: "flex", alignItems: "baseline", gap: 8 }}>
              <span style={{ fontSize: 28, fontWeight: 800, color: plan.color }}>{plan.price}</span>
              <span style={{ color: "#6b7280", fontSize: 13 }}>/month</span>
              <span style={{ marginLeft: "auto", fontSize: 12, color: "#4b5563" }}>{plan.yearly}</span>
            </div>

            <div style={{ marginBottom: 20, flex: 1 }}>
              {[["CPU", plan.cpu], ["RAM", plan.ram], ["Storage", plan.storage], ["Bandwidth", plan.bandwidth]].map(([k, v]) => (
                <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid rgba(255,255,255,0.05)", fontSize: 14 }}>
                  <span style={{ color: "#6b7280" }}>{k}</span>
                  <span style={{ color: "#e5e7eb", fontWeight: 600 }}>{v}</span>
                </div>
              ))}
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 20 }}>
              {plan.tags.map(t => (
                <span key={t} style={{ padding: "3px 10px", borderRadius: 999, fontSize: 12, background: `${plan.color}15`, color: plan.color, border: `1px solid ${plan.color}30` }}>{t}</span>
              ))}
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <Link to="/contact" style={{ flex: 1, background: plan.color, border: "none", borderRadius: 10, color: "#030305", fontWeight: 700, fontSize: 14, padding: "12px", textAlign: "center", textDecoration: "none", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                Get Started →
              </Link>
              <button onClick={() => wa(plan.name)} title="WhatsApp" style={{ background: "rgba(34,197,94,0.1)", border: "1px solid rgba(34,197,94,0.3)", borderRadius: 10, color: "#22c55e", cursor: "pointer", padding: "12px 14px", fontSize: 18 }}>
                💬
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Custom CTA */}
      <div style={{ maxWidth: 700, margin: "48px auto 0", padding: "28px", borderRadius: 20, background: "rgba(188,19,254,0.06)", border: "1px solid rgba(188,19,254,0.2)", textAlign: "center" }}>
        <div style={{ fontWeight: 700, fontSize: 18, color: "#fff", marginBottom: 8 }}>Need a custom GPU configuration?</div>
        <div style={{ color: "#9ca3af", fontSize: 14, marginBottom: 20 }}>Multi-node GPU clusters, NVLink bridges, or custom VRAM — talk to our team.</div>
        <button onClick={() => wa("Custom GPU")} style={{ background: "rgba(34,197,94,0.12)", border: "1px solid rgba(34,197,94,0.3)", borderRadius: 10, color: "#22c55e", fontWeight: 700, fontSize: 14, padding: "12px 28px", cursor: "pointer" }}>
          💬 Chat on WhatsApp
        </button>
      </div>
    </div>
  );
}
